import React from "react";
import { RecommendedProductsBlockProps } from "../../types/search";
import { normalizeToRecommendedProducts } from "../../search-core/recommendations/converters";
import RecommendedProductCard from "./RecommendedProductCard";
import { ApiCartService } from "../../services/api-cart-service";
import "../../styles.css";

/**
 * RecommendedProductsBlock - Displays a grid of recommended product cards
 *
 * This component shows a list of recommended products in a grid layout.
 * No functionality except optional click handlers for future use.
 */
const RecommendedProductsBlock: React.FC<RecommendedProductsBlockProps> = ({
  products,
  onProductActionClick,
}) => {
  const cartService = new ApiCartService();

  const handleProductActionClick = async (productId: string | number) => {
    // If parent provided a custom handler, use it
    if (onProductActionClick) {
      onProductActionClick(productId);
      return;
    }

    // Otherwise, default behavior: add to cart
    try {
      const id = typeof productId === 'number' ? productId : parseInt(productId as string, 10);
      if (isNaN(id)) {
        console.error('Invalid product ID:', productId);
        return;
      }
      const response = await cartService.addToCart(id, 1);
      console.log('Added to cart:', response);
      // TODO: show success notification
    } catch (error) {
      console.error('Failed to add to cart:', error);
      // TODO: show error notification
    }
  };

  // Convert ProductResult to RecommendedProduct for UI compatibility
  const uiProducts = normalizeToRecommendedProducts(products);

  return (
    <div className="recommended-products-block">
      <div className="block-header">
        <h3 className="block-title">Рекомендуем для вас</h3>
      </div>

      {uiProducts.length > 0 ? (
        <div className="products-flex">
          {uiProducts.map((product) => (
            <RecommendedProductCard
              key={product.id}
              product={product}
              onActionClick={handleProductActionClick}
            />
          ))}
        </div>
      ) : (
        <p className="empty-message">Нет рекомендуемых товаров</p>
      )}
    </div>
  );
};

export default RecommendedProductsBlock;
